var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/core-js/modules/_an-object.js
// module id = ../../../../core-js/modules/_an-object.js
// module chunks = 2